import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import CategorySelector from './CategorySelector';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const BecomeATasker = () => {
    const [cities, setCities] = useState([]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetch(`${API_URL}/api/cities`);
                const data = await response.json();
                setCities(data);
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };

        fetchCities();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const selectedServices = formData.getAll('services');
        const customService = formData.get('customService');
        if (customService) {
            selectedServices.push(customService);
        }

        console.log('Servicios seleccionados:', selectedServices);
    };

    return (
        <Container className="my-5 local-hire-design">
            <Row className="text-center mb-5">
                <Col>
                    <h1 className="title text-primary fw-bold">Unite a nuestra comunidad</h1>
                    <p className="lead text-secondary">Que todos te conozcan por tus servicios.</p>
                </Col>
            </Row>
            <Row className="mb-5">
                <Col className="text-center text-primary">
                    <h2>Beneficios de Unirte a la comunidad</h2>
                </Col>
            </Row>
            <Row className="mb-5">
                {["Flexibilidad", "Ganancias competitivas", "Apoyo de la comunidad"].map((title, index) => (
                    <Col md={4} key={index}>
                        <Card className="h-100 text-center shadow-sm rounded-lg">
                            <Card.Body>
                                <Card.Title className="fw-bold text-primary">{title}</Card.Title>
                                <Card.Text className="text-muted">{index === 0 ? "Decide cuándo y cuánto trabajar." : index === 1 ? "Gana dinero según tus habilidades y experiencia." : "Acceso a una red de servicios y soporte profesional."}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Row className="mb-5">
                <Col md={{ span: 6, offset: 3 }}>
                    <h2 className="text-center mb-4 text-primary">Registrate para comenzar</h2>
                    <Form onSubmit={handleSubmit} className="shadow-sm p-4 rounded-lg">
                        {['Nombre completo', 'Correo electrónico', 'Teléfono'].map((placeholder, index) => (
                            <Form.Group className="mb-3" key={index}>
                                <Form.Control type={index === 1 ? "email" : "text"} placeholder={placeholder} required className="rounded-pill shadow-sm" />
                            </Form.Group>
                        ))}
                        <Form.Group className="mb-3">
                            <Form.Select aria-label="Seleccionar localidad" className="rounded-pill shadow-sm">
                                <option value="">Selecciona tu localidad</option>
                                {cities.map(city => (
                                    <option key={city._id} value={city.city}>{city.city}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <h3 className="text-center mb-3">Selecciona los servicios que prestas</h3>
                        <Row>
                            {Object.entries(CategorySelector).map(([category, services]) => (
                                <Col md={6} key={category} className="mb-3">
                                    <Card className="shadow-sm rounded-lg">
                                        <Card.Body>
                                            <Card.Title className="fw-bold text-primary">{category}</Card.Title>
                                            {services.map(service => (
                                                <Form.Check key={service} type="checkbox" label={service} name="services" className="text-muted" />
                                            ))}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        <Button variant="primary" type="submit" className="w-100 rounded-pill shadow-sm">Enviar solicitud</Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default BecomeATasker;